export const BancoDoAutoTabs = {
  'banco-do-auto': {
    id: 0,
    href: 'banco-do-auto',
    label: 'Carros',
    navigate: true,
    t: '',
  },
  'financiamento-de-motos': {
    id: 1,
    href: 'financiamento-de-motos',
    label: 'Motos',
    navigate: true,
    t: '',
  },
  'financiamento-de-pesados': {
    id: 2,
    href: 'financiamento-de-pesados',
    label: 'Pesados',
    navigate: true,
    t: '',
  },
};
